import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Layouts
import RootLayout from './layouts/RootLayout';
import MainLayout from './layouts/MainLayout';
import AuthLayout from './layouts/AuthLayout';
import LandingLayout from './layouts/LandingLayout';

// Pages
import HomeRedirect from './pages/HomeRedirect';
import HomePage from './pages/HomePage';
import LandingPage from './pages/LandingPage';
import EntrarPage from './pages/EntrarPage';
import RegistrarPage from './pages/RegistrarPage';
import EntrarDiscordPage from './pages/EntrarDiscordPage';
import ObraPage from './pages/ObraPage';
import CapituloPage from './pages/CapituloPage';
import ColecaoPage from './pages/ColecaoPage';
import MeuPerfilPage from './pages/MeuPerfilPage';
import PlanosPage from './pages/PlanosPage';
import PesquisarPage from './pages/PesquisarPage';
import RankingPage from './pages/RankingPage';
import HistoricoPage from './pages/HistoricoPage';
import AtualizadosPage from './pages/AtualizadosPage';
import AtualizacoesPage from './pages/AtualizacoesPage';
import EmDesenvolvimentoPage from './pages/EmDesenvolvimentoPage';
import EnPage from './pages/EnPage';
import VpnPage from './pages/VpnPage';
import ComunidadePage from './pages/ComunidadePage';
import PerfilPage from './pages/PerfilPage';
import ListasPage from './pages/ListasPage';
import ListaDetalhePage from './pages/ListaDetalhePage';
import NovelFamosasPage from './pages/NovelFamosasPage';
import AgradecimentoVipPage from './pages/AgradecimentoVipPage';
import MinhaColecao from './pages/MinhaColecao';
import TermosPage from './pages/TermosPage';
import ContinueLendoPage from './pages/ContinueLendoPage';
import { RouteAnalytics } from './components/analytics/RouteAnalytics';

// Note: wrappers might still be useful for data fetching logic if needed, 
// but for now mapping directly to the refactored pages.

function App() {
    return (
        <BrowserRouter>
            <RouteAnalytics />
            <Routes>
                <Route element={<RootLayout />}>
                    {/* Root/Redirect */}
                    <Route path="/" element={<HomeRedirect />} />

                    {/* Landing Group */}
                    <Route element={<LandingLayout />}>
                        <Route path="/landing" element={<LandingPage />} />
                    </Route>

                    {/* Auth Group */}
                    <Route element={<AuthLayout />}>
                        <Route path="/entrar" element={<EntrarPage />} />
                        <Route path="/entrar-discord" element={<EntrarDiscordPage />} />
                        <Route path="/registrar" element={<RegistrarPage />} />
                    </Route>

                    {/* Main Group */}
                    <Route element={<MainLayout />}>
                        <Route path="/inicio" element={<HomePage />} />
                        <Route path="/en" element={<EnPage />} />
                        <Route path="/atualizados" element={<AtualizadosPage />} />
                        <Route path="/atualizacoes" element={<AtualizacoesPage />} />
                        <Route path="/obra/:id" element={<ObraPage />} />
                        <Route path="/capitulo/:id" element={<CapituloPage />} />
                        <Route path="/colecao" element={<ColecaoPage />} />
                        <Route path="/continue-lendo" element={<ContinueLendoPage />} />
                        <Route path="/demo/minha-colecao-listas" element={<MinhaColecao />} />
                        <Route path="/comunidade" element={<ComunidadePage />} />
                        <Route path="/perfil/:nick" element={<PerfilPage />} />
                        <Route path="/meu-perfil" element={<MeuPerfilPage />} />
                        <Route path="/planos" element={<PlanosPage />} />
                        <Route path="/pesquisar" element={<PesquisarPage />} />
                        <Route path="/ranking" element={<RankingPage />} />
                        <Route path="/historico" element={<HistoricoPage />} />
                        <Route path="/listas" element={<ListasPage />} />
                        <Route path="/listas/:id" element={<ListaDetalhePage />} />
                        <Route path="/novel-famosas" element={<NovelFamosasPage />} />
                        <Route path="/agradecimento-vip" element={<AgradecimentoVipPage />} />
                        <Route path="/em-desenvolvimento" element={<EmDesenvolvimentoPage />} />
                        <Route path="/vpn" element={<VpnPage />} />
                        <Route path="/termos" element={<TermosPage />} />
                    </Route>

                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
